import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-profile-icon',
  templateUrl: './profile-icon.component.html',
  styleUrls: ['./profile-icon.component.sass'],
  encapsulation: ViewEncapsulation.None,
})
export class ProfileIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
